import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../../../utils";
import PageSubheader from "../../../../../components/PageSubheader";
import Form from "../form";

interface Props {
  intl: IntlShape;
  backURL: string;
}

const CreateIncidentType = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.incident.type.create.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-incident-type-create"
        goBackURL={backURL}
      />

      <Form {...props} edition={false} />
    </>
  );
};

export default withOneColLayout(injectIntl(CreateIncidentType));
